import React from "react";
import "./DevPlan.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class DevPlan extends React.Component {
    render() {
        return(
<div>
    <Nav/>
    <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Project">01 Investment Environment</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProLoc">Transportation and Logistics</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/InvestRegis"> 02 Investment Registration</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab">03 Industries & Parks</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoBusiness">Eco-Business Park</a></p>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/EcoInov">Eco-Innovation</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Overall">Overall Introduction</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab">04 Real Estate Development</p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevPlan">Development Plan</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevMile">Development Milestone</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/DevMile">Development Milestone</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">05 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
            </div>
          </div>
        <div className="col-8">
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>Development Plan</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}></p>
        <p className="text-justify">With the Start-Up Area almost completed, the Good Morning Bamboo Bamboo Eco-City (the Eco-City) will be ready to embark on its next developmental phase in the central site, which will be adjacent to the Start-Up Area. Within the central site, there will be more commercial and cultural developments. An Eco-Tourism Island incorporated ecological gardens, as well as leisure and commercial elements will be established on the west bank of an artificial lake to be developed. Destiny High School will be constructed by the end of 2021 while a Good Morning Bamboo Friendship Park and a library will also be launched. As the master developer of the Eco-City, Good Morning Bamboo Agro-Forestry and Investment Services will be releasing a few choice residential land plots to the market and looks forward to joining hands with interested investors and developers in the first and next phase of the Eco-City’s development.<br/><br/>
        If you are keen to invest in the Eco-City, Please contact Founder and CEO who can assist and guide you on how to get started.
        <br/><br/><span style={{fontWeight:'bold'}}>Residential & Commercial Land Development Hotline</span><br/>
Samuel Worwui<br/>
Tel: +233 509160497<br/>
Email: .samuel.worwui@gmail.com,


</p>
   
       </div>
      
     </div>
   </div>
</div>
        )
    }
}
export default withRouter(DevPlan);